<template>
	<div class="flexCol alit">
		<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%B9%A1%E6%9D%91/11.png"
			alt="" />

		<div class="title" style="margin-top: 40px;margin-bottom: 15px;">和美乡村数字三农系统功能</div>
		<div class="title-desc">智能监测·智能灌溉</div>
		<div class="desc" style="margin-top: 20px;">
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;千广和美乡村数字三农系统以数字技术为底座，以“产业兴旺、生态宜居、乡风文明、治理有效、生活富裕”为目标，构建一个贯穿乡村生产、生活、生态的“数字孪生乡村”。其核心功能可概括为以下五大板块：
			<h2 style="margin: 5px 0;">一、 乡村治理“一张网”</h2>
			<h4 style="margin: 5px 0;">智慧党建与管理：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：实现村务、财务、党务“三务”在线公开，党员管理数字化，畅通村民议事、监督渠道。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：提升基层治理透明度与效率，夯实组织基础。<br />
			<h4 style="margin: 5px 0;">网格化与应急指挥：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：整合治安监控、老人关怀、矛盾纠纷调解等网格事件，实现一网统管、联动处置。具备防灾减灾、疫情防控等应急指挥调度功能。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：保障乡村平安，提升应急响应速度。<br />
			<h4 style="margin: 5px 0;">数字民情档案：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：建立包含人口、房屋、土地、就业等信息的村级数字档案，动态更新。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：实现“以房管人、以地管事”，为精准施策提供数据基础。<br />
			<h2 style="margin: 5px 0;">二、 产业兴旺“一条链”</h2>
			<h4 style="margin: 5px 0;">农业生产智能化：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：集成前文所述的大田智慧农业、智慧养殖等系统，实现对特色产业的精准管理和降本增效。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：推动农业现代化，提升土地产出率和劳动生产率。<br />
			<h4 style="margin: 5px 0;">产业链协同与溯源：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：连接生产、加工、仓储、物流、营销各环节，实现产销对接。为优质农产品提供全程溯源功能，打造乡村品牌。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：延长产业链，提升价值链，保障食品安全，促进农民增收。<br />
			<h4 style="margin: 5px 0;">农村电商与文旅服务：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：提供本地电商平台接口，助力农产品出村进城。整合乡村旅游资源，实现民宿、景点、农事体验的在线展示与预订。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：发展新业态，激活乡村经济新动能。<br />
			<h2 style="margin: 5px 0;">三、 生态宜居“一幅图”</h2>
			<h4 style="margin: 5px 0;">人居环境监测：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：通过视频AI和传感器，监测垃圾堆放、污水乱排、河道水质等情况，实现自动预警和闭环处理。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：助力美丽乡村建设，实现长效管护。<br />
			<h4 style="margin: 5px 0;">绿色生态守护：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：监控森林防火、病虫害、秸秆焚烧等，保护乡村生态环境。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：守护绿水青山，推动可持续发展。<br />
			<h2 style="margin: 5px 0;">四、 乡风文化“一云端”</h2>
			<h4 style="margin: 5px 0;">数字文化站：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：建立线上村史馆、文化广场，展示本地非遗、民俗，开展线上文化培训与活动。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：传承乡村文脉，丰富农民精神文化生活。<br />
			<h4 style="margin: 5px 0;">文明积分系统：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：将村民参与环境卫生、志愿服务、遵纪守法等行为量化积分，并可在线兑换奖励。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：引导村民自觉参与乡村建设，培育文明乡风。<br />
			<h2 style="margin: 5px 0;">五、 民生服务“一窗口”</h2>
			<h4 style="margin: 5px 0;">“一网通办”下沉：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：对接政务服务平台，让村民通过手机或村内终端即可办理社保、医疗、养老等高频事项，实现“小事不出村”。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：打通公共服务“最后一公里”，提升农民幸福感。<br />
			<h4 style="margin: 5px 0;">智慧医疗与养老：</h4>
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;功能：提供在线问诊、健康档案查询、老人智能手环监护等服务。<br />
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;价值：缓解农村看病难、养老难问题。<br /><br />
			
			&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;千广和美乡村数字三农系统是乡村的“数字基座”和“智慧管家”。它通过将治理、经济、生态、文化、民生五大维度全面数字化，实现了：
			对于政府：实现了对乡村发展情况的“一图感知、一体调度、科学决策”。
			对于村民：享受到了“办事更方便、生活更安全、增收有门路”的数字化红利。
			它最终目标是赋能一个有温度、有活力、有底蕴、可持续的和美乡村。



		</div>
		<!-- <div class="title" style="margin-top: 40px;margin-bottom: 15px;">"产业大脑" 延链、补链</div> -->
		<div class="flex alit justc" style="margin-top: 20px;">
			<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%B9%A1%E6%9D%91/3.png" style="width: 39%;" alt="" />
			<img src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%B9%A1%E6%9D%91/2.png"  style="width: 39%;margin-left: 2%;" alt="" />
		</div>
		<img style="width: 80%;margin-top: 20px;margin-bottom: 20px;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%B9%A1%E6%9D%91/1.png"
			alt="" />
		<!-- <img style="width: 50%;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E4%B8%9A%E5%A4%A7%E8%84%91/2.png"
			alt="" /> -->
		<!-- <video style="width: 70%;" src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E5%A4%A7%E7%94%B0/%E5%8D%83%E5%B9%BF%E9%81%A5%E6%84%9F%2BAI.mp4" controls></video> -->
		<!-- <img style="width: 80%;margin: 10px 0;"
			src="https://qgst.obs.cn-southwest-2.myhuaweicloud.com/%E5%AE%98%E7%BD%91/%E4%BA%A7%E5%93%81%E4%B8%8E%E6%9C%8D%E5%8A%A1/%E7%81%AB%E9%94%85%E4%BA%A7%E4%B8%9A/%E5%B9%B3%E5%8F%B0%E6%9C%8D%E5%8A%A1.png"
			alt="" /> -->
	</div>
</template>

<script>
</script>

<style scoped>
	.sj-cont {
		width: 24%;
		background-color: rgb(12 84 166);
		color: #fff;
		height: 50px;
		text-align: center;
		line-height: 50px;
		font-size: 24px;
		margin-top: 10px;
	}

	.desc {
		width: 80%;
		font-size: 24px;
	}

	img {
		width: 100%;
	}

	.title {
		text-align: center;
		font-weight: 900;
		font-size: 34px;
		margin: 20px 0;
		color: rgb(86 146 48);
	}

	.title-desc {
		text-align: center;
		font-size: 17px;
		color: rgb(151 151 151);
		margin-bottom: 20px;
	}
</style>